const localeEs = {
  es: {
    LANDING_TITLE1: '¡{{name}},\nte damos la bienvenida a\n',
    LANDING_TITLE2: 'Crehana!',
    LANDING_COPY:
      'Somos la plataforma aliada de {{ORG}} que potenciará tu crecimiento profesional y personal.',
    LANDING_START: 'Conocer mi panel',

    HEADER_BREADCRUMB_TITLE_1: 'Bienvenida',
    HEADER_BREADCRUMB_TITLE_2: 'Conoce más',
    HEADER_BREADCRUMB_TITLE_3: 'Recursos',

    STEPPER_NEXT: 'Continuar',
    STEPPER_BACK: 'Atrás',

    FEATURE_TITLE: 'Lo que disponemos para ti',
    FEATURE_TITLE_1: 'Diseña tu experiencia',
    FEATURE_DESCRIPTION_1:
      'Personaliza tu información para acceder a oportunidades de aprendizaje y desarrollo más relevantes para ti.',
    FEATURE_TITLE_2: 'Impulsa tu crecimiento',
    FEATURE_DESCRIPTION_2:
      'Accede a contenidos de formación y aprendizaje diseñados para potenciar tus habilidades y acompañarte en tu evolución profesional. *',
    FEATURE_TITLE_3: 'Involúcrate en tu desarrollo',
    FEATURE_DESCRIPTION_3:
      'Sé parte activa de evaluaciones, reconocimientos y otros procesos que fortalecen tu desarrollo y el de tu equipo. *',
    FEATURE_INFO: '* Según los productos que adquirió tu compañía',

    RESOURCES_TITLE: 'Ayuda y recursos',
    RESOURCES_SUBTITLE_1: 'Chatbot',
    RESOURCES_DESCRIPTION_1:
      'En nuestra plataforma, contamos con un chat de soporte para asesorarte sobre el uso de la plataforma.',
    RESOURCES_SUBTITLE_2: 'Centro de Ayuda',
    RESOURCES_DESCRIPTION_2:
      'Cuando necesites guías o tutoriales, también puedes accede a la opción de “Ayuda”.',

    POWERED_BY: 'Powered by',
  },
};

export default localeEs;
